export const LOCAL_STORAGE_REDIRECT_URL = 'inscribe.redirect_url';
